import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  { title: 'User 1', prop: 'user_id_low', references: 'admin/users', referenceProp: 'name' },
  { title: 'User 2', prop: 'user_id_high', references: 'admin/users', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' }
]

const filters = [{
  name: 'Filter by user 1',
  prop: 'filters.user_id_low',
  type: 'autocomplete',
  references: 'admin/users',
  dataHydrator: userEmailHydrator,
  displayProp: 'displayVal',
  referenceProp: 'fullname',
  enabled: true
}, {
  name: 'Filter by user 2',
  prop: 'filters.user_id_high',
  type: 'autocomplete',
  references: 'admin/users',
  dataHydrator: userEmailHydrator,
  displayProp: 'displayVal',
  referenceProp: 'fullname',
  enabled: true
}]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const BuddyMatches = props => (
  <List
    title='Buddy Matches'
    apiPath='admin/buddy_matches'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default BuddyMatches
